// Photo URLs now come straight from Cloud Storage's getDownloadURL() (see
// lib/storage.js) — already complete, directly-usable URLs — so this is a
// passthrough kept only so callers don't need to change.
export function authedFileUrl(url) {
  return url || "";
}
